import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { ProgressBar } from 'primereact/progressbar';
import { useAuth } from '../contexts/AuthContext';
import AccessState from './AccessState';

const AccessGate = ({
  children,
  canAccess,
  title,
  message,
  actionLabel,
  actionTo,
  autoRedirectTo,
  autoRedirectDelayMs,
}) => {
  const { accessContext, isAuthReady, isLoggedIn, logout } = useAuth();

  useEffect(() => {
    if (!isAuthReady) return;
    if (!isLoggedIn) return;
    if (accessContext) return;
    Promise.resolve(logout()).catch(() => {});
  }, [accessContext, isAuthReady, isLoggedIn, logout]);

  if (!isAuthReady) {
    return (
      <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!accessContext) {
    return (
      <AccessState
        title="Session Unavailable"
        message="We could not load your access profile. Please sign in again."
        actionLabel="Go To Login"
        actionTo="/login"
        autoRedirectTo="/login"
        autoRedirectDelayMs={2000}
      />
    );
  }

  if (typeof canAccess === 'function' && !canAccess(accessContext)) {
    return (
      <AccessState
        title={title}
        message={message}
        actionLabel={actionLabel}
        actionTo={actionTo}
        autoRedirectTo={autoRedirectTo}
        autoRedirectDelayMs={autoRedirectDelayMs}
      />
    );
  }

  return children;
};

export default AccessGate;